import fitvids from "fitvids";
export const WysiwygBlock = () => {
  fitvids(".wysiwyg-block");
};
